import moment from "moment";
import GraphContent from "@/components/graphContent/graph_content";

export class MakeChartData {
  private data: any[];

  constructor(data: any[]) {
    this.data = data;
  }

  public makeThresholdData(
    labels: string[],
    sensorData: number[][],
    threshold: GraphContent["dynamoThreshold"],
    colors: string[]
  ) {
    const maxLineColor = "rgba(255, 10, 10, 1)";
    const minLineColor = "rgba(10, 10, 255, 1)";
    if (threshold.max.enabled) {
      const rowData: number[] = sensorData[0].map(() => {
        return Number(threshold.max.value);
      });
      sensorData.unshift(rowData);
      labels.unshift("上限");
      colors.unshift(maxLineColor);
    }
    if (threshold.min.enabled) {
      const rowData: number[] = sensorData[0].map(() => {
        return Number(threshold.min.value);
      });
      sensorData.push(rowData);
      labels.push("下限");
      colors.push(minLineColor);
    }
  }

  public makeGraphData(attribute: string) {
    const graphData: number[] = [];
    this.data.forEach((obj: { [key: string]: any }) => {
      if (typeof obj[attribute] !== "undefined") {
        graphData.push(Number(obj[attribute]));
      }
    });
    return graphData;
  }

  public makeTimeData(
    sortKey: string,
    attribute: string,
    timeZone: string,
    format: string,
    timeFormat: string,
    dataTimezone: string
  ) {
    const timeData: string[] = [];
    const dateFormat: string = format === null ? "MM-DD HH:mm:ss" : format;
    this.data.forEach((obj: { [key: string]: any }) => {
      if (typeof obj[attribute] !== "undefined") {
        // 時刻フォーマット文字列内の"/"が特別な文字と認識されてしまうのでハイフンに置換
        if (timeFormat.includes("/")) {
          obj[sortKey] = obj[sortKey].replace(/\//g, "-");
        }
        if (timeFormat === "x") {
          timeData.push(
            moment
              .utc(Number(obj[sortKey]))
              .utcOffset(timeZone)
              .format(dateFormat)
          );
        } else if (timeFormat === "X") {
          timeData.push(
            moment
              .utc(Number(obj[sortKey]) * 1000)
              .utcOffset(timeZone)
              .format(dateFormat)
          );
        } else if (timeFormat.includes("Z")) {
          timeData.push(
            moment(obj[sortKey])
              .utcOffset(timeZone)
              .format(dateFormat)
          );
        } else {
          timeData.push(
            moment(obj[sortKey])
              .utcOffset(dataTimezone, true)
              .utcOffset(timeZone)
              .format(dateFormat)
          );
        }
      }
    });
    return timeData;
  }
}
